import { useContext } from "react";

import {
  AdminWorkspaceContext,
  WorkspaceContext,
} from "@app/common/workspaces/WorkspaceContext";

const useWorkspace = () => useContext(WorkspaceContext);

// workspace context from an admin/owner view
export const useAdminWorkspace = () => useWorkspace() as AdminWorkspaceContext;

export default useWorkspace;
